import intl from 'react-intl-universal';

export function checkNullObj (obj) {
  return Object.keys(obj).length === 0
}
export function loadScript(url, /* callback */) {
  return new Promise((resolve, reject) => {
    let head = document.getElementsByTagName('head')[0];
    let script = document.createElement('script');
    script.type = 'text/javascript';

    if (script.readyState) {
      script.onreadystatechange = function() {
        
        if (script.readyState == 'loaded' || script.readyState == 'complete') {
          script.onreadystatechange = null;
          resolve();
        }
      };
    } else {
      // script.οnlοad=function(){
      //   resolve();
      // }
      script.onload = resolve;
      script.onerror = reject;
    }
    script.src = url;
    head.appendChild(script);
  });
}
export function loadImage(url, attrs /* callback */) {
  return new Promise((resolve/* , reject */) => {
    let head = document.getElementsByTagName('head')[0];
    let image = document.createElement('img');
    if(attrs) {
      attrs.id && image.setAttribute('id', id);
      //'display:none;'
      attrs.style && image.setAttribute('style', attrs.style);
    }

    const onLoaded = (e)=>{
      resolve(e);
    }
    const onError = (e)=>{
      console.error("loadImage onError -> e", e)
      //reject(e);
    }

    if (image.readyState) {
      image.onreadystatechange = function() {
        
        if (image.readyState == 'loaded' || image.readyState == 'complete') {
          image.onreadystatechange = null;
          onLoaded();
        }
      };
    } else {

      image.onload = onLoaded;
      image.onerror = onError;
    }
    image.src = url;
    head.appendChild(image);
  });
}

export const DOMAINS_TYPE = {
  CN       : ['online.foxitsoftware.cn'],
  JP       : ['pdfonline-jp.foxitsoftware.com'],
  PDFONLINE: ['pdfonline.foxitsoftware.com'],
  FZK8S    : ['online-fzk8s.foxitcloud.com'],
  DEMO4    : ['online-demo4.connectedpdf.com'],
  LOCAL    : ['localhost', '127.0.0.1']
}
/**
 * @export
 * @param {Array} domains
 * @returns {Boolean}
 */
export function isParentNode(p, c2){
  var c = c2;
  while(c.parentNode){
  c = c.parentNode;
  if(c == p)
  return true;
  }
  return false;
}
export function isInTargetDomains(domains) {
  if(!domains)return false;
  let baseUrl = getBaseUrl();
  let item = domains.find((target)=>{
    if(baseUrl.indexOf(target)!== -1){
      return true;
    }
    return false;
  })
  return !!item;
}
window.isInTargetDomains = isInTargetDomains;
export function isCNDomain() {
  //return true;
  return isInTargetDomains(DOMAINS_TYPE.CN);
}
export function isPdfOnlineDomain() {
  //return true;
  if(getQueryVariable('server_config') === 'pdfonline'){
    return true;
  }
  return isInTargetDomains(DOMAINS_TYPE.PDFONLINE);
}
export function isJPDomain() {
  //return true;
  return isInTargetDomains(DOMAINS_TYPE.JP);
}
export function isFZK8SDomain() {
  //return true;
  return isInTargetDomains(DOMAINS_TYPE.FZK8S);
}
export function isDemo4Domain() {
  //return true;
  if(getQueryVariable('server_config') === 'p-demo'){
    return true;
  }
  return isInTargetDomains(DOMAINS_TYPE.DEMO4);
}
export function isDevDomain() {
  return isInTargetDomains(DOMAINS_TYPE.LOCAL);
}

export function isMobile() {
  return window.deviceInfo && window.deviceInfo.isMobile;
}

const langs = {
  zh:'zh-CN',
  ko:'ko-KR',
  ja:'ja-JP',
  en:'en-US'
}

export function getBrowserDefaultLanguage() {
  let language = navigator.language || navigator.userLanguage;
  // fix error when language is one of 'zh','en',...
  if(langs[language] !== void 0){
    language = langs[language];
  }
  return language;
}

export function getBrowserLanguage() { 
  let language = navigator.language || navigator.userLanguage;
  if(isCNDomain()){
    language = 'zh-CN'
  }/*else if(isPdfOnlineDomain()){ 
    language = 'en-US'
  }*/ else {
    let storageLanguage = storageGetItem(localStorage, 'language');
    if (storageLanguage) {
      language = storageLanguage;
    }
  }
  // fix error when language is one of 'zh','en',...
  if(langs[language] !== void 0){
    language = langs[language];
  }

  let langInUrl = getQueryVariable('lang');
  if(langInUrl)language = langInUrl;
  //let lang = navigator.language||navigator.userLanguage;
  let lang = language.substr(0, 2);
  if ((!isPdfOnlineDomain() && lang === 'zh') || lang === 'ja' ||
      (!isPdfOnlineDomain() && lang === 'ko')) {
    return { lang: lang, full: language }; // zh-CN ja-JP ko-KR;
  } else {
    return { lang: 'en', full: 'en-US' }; // en-US;
  }
}

export const prop = (obj, attr) => obj[attr];
export const updateProp = (obj, key, attr) => obj[key] = attr;

//example: window.open => windowAction(window, 'open', args);
export function windowActionFn(_window, fnName, args){
  if(!_window && typeof _window[fnName] !== 'function')return;
  return _window[fnName](...args);
}
export function storageGetItem(storage, key) {
  if(!storage)return null;
  return storage.getItem(key);
}
//window.localStorage.removeItem
export function storageRemoveItem(storage, key) {
  if(!storage)return null;
  return storage.removeItem(key);
}
export function storageClear(storage) {
  storage && storage.clear();
}

export function storageSetItem(storage, key, value) {
  storage && key && storage.setItem(key, value);
}
export function isMore20201231(){
  /*// local time '2021/01/01 00:00:00'
  let date = new Date(2021, 0, 1, 0, 0, 0).getTime();
  // now
  let nowDate = new Date().getTime();
  let dateUrlParam = getQueryVariable('now_date')
  if(dateUrlParam){
    nowDate = new Date(1609430400000 +1000*3600*24);
  }
  if(nowDate>date){
    return true;
  }*/
  return false;
}

export function blobToBase64(blob) {
  return new Promise((resolve)=>{
    let reader = new FileReader();
    reader.readAsDataURL(blob);
   
    reader.onloadend = (/* e */) => {
      let data = reader.result; 
      resolve({ret:0, data: data});
    }
    reader.onerror = (error) =>{
      resolve({ret:999, data: error})
    }
  })
}

export function getAppTitle(/*lang*/) {
  /*if (!lang) {
    let info = getBrowserLanguage();
    lang = info.lang;
  }
  if (lang === 'en') {
    // 'en-US'
    return 'Foxit PhantomPDF Online - Edit PDF';
  }
  return '福昕高级PDF编辑器网页版 - 编辑PDF';*/
  return intl.get("PhantomPDF.Online.AppTitle");
}

export function UTCTimeFormat(time){
  if(time.indexOf('T')!== -1)return time;
  //
  const words = time.split(':')
  let hasSecond = words.length === 3;
  //let hasMiniSecond = time.indexOf('.') !== -1;

  //if(time.)
  //"2019-08-10T02:37:54.770Z"
  let _time = time.replace(' ', 'T');
  !hasSecond && (_time += ':00')
  _time += 'Z'
  return _time;
}

export function convertUTCToLocale(utcTimeString, isHideSeconds) {
  let dateToHandle = new Date(utcTimeString);
  let year = dateToHandle.getFullYear();
  let month = dateToHandle.getMonth() + 1 < 10 ? `0${dateToHandle.getMonth() + 1}` : dateToHandle.getMonth() + 1;
  let date = dateToHandle.getDate() < 10 ? `0${dateToHandle.getDate()}` : dateToHandle.getDate();
  let hours = dateToHandle.getHours() < 10 ? `0${dateToHandle.getHours()}` : dateToHandle.getHours();
  let minutes = dateToHandle.getMinutes() < 10 ? `0${dateToHandle.getMinutes()}` : dateToHandle.getMinutes();
  let seconds = dateToHandle.getSeconds() < 10 ? `0${dateToHandle.getSeconds()}` : dateToHandle.getSeconds();
  if(isHideSeconds){
    return `${year}/${month}/${date} ${hours}:${minutes}`;
  }

  return `${year}/${month}/${date} ${hours}:${minutes}:${seconds}`;
}
export function utcTimeString(utcTime){
  let date  = new Date(utcTime);
  let year  = date.getUTCFullYear();
  let month = date.getUTCMonth();
  let day   = date.getUTCDate();
  month     = month+1<10?`0${month+1}`: month+1;
  day       = day+1<10?`0${day+1}`    : day;
  return `${month}/${day}/${year}`;
}

export function UTCTimeToLocale(time){
  let t = UTCTimeFormat(time);
  return convertUTCToLocale(t);
}

export function getFileSize(size) {
  const B_TO_KB = 1024;
  const B_TO_MB = 1048576;

  if (size >= 1048576) {
    return `${(size / B_TO_MB).toFixed(2)}MB`;
  } else {
    return `${(size / B_TO_KB).toFixed(2)}KB`;
  }
}
export function convertFileSizeToKBSize(size) {
  const sizeLower = size.toLowerCase()
  const sizeFloat = parseFloat(size)

  if (sizeLower.indexOf('kb') > -1) {
    return sizeFloat
  }

  if (sizeLower.indexOf('mb') > -1) {
    return sizeFloat * 1024
  }

  if (sizeLower.indexOf('gb') > -1) {
    return sizeFloat * 1024 * 1024
  }
}

export function getFileNameWithoutExtension(text) {
  let pattern = /\.{1}[a-z]{1,}$/;

  if (pattern.exec(text) !== null) {
    return text.slice(0, pattern.exec(text).index);
  } else {
    return text;
  }
}

export function getFileNameByUrl(url) {
  let filename = url.substring(url.lastIndexOf('/')+1);
  return filename;
}

export function handlerFileNameWithoutExtension(fileName) {
  if (/(.pdf)$/.test(fileName)) {
    return fileName;
  } else {
    return `${fileName}.pdf`;
  }
}

//   /^(?![0-9]+$)(?![a-z]+$)(?![A-Z]+$)(?!([^(0-9a-zA-Z)])+$)^.{8,16}$/
//   /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{8,16}$/
let passwordReg = /(?!^\d+$)(?!^[A-Za-z]+$)(?!^[^A-Za-z0-9]+$)(?!^.*[\u4E00-\u9FA5].*$)^\S{8,16}$/
export function isValidPassword(password){
  if(!password)return false;
  let flag = passwordReg.test(password);
  return flag;
}
export function isValidURL(input){
  return !!input.match(/(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)(:\d{0,5})?((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g);
}

export function isValidIP(ip) {
  var reg = /(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])/
  return reg.test(ip);
} 
export function isBlank(text) {
  return (!text || /^\s*$/.test(text));
}
export function removeCJK(text) {
  if (!text) {
    return ''
  }
  let reg = /[\u2E80-\u9FFF]/g;
  return text.replace(reg, "");
}

export function getQueryVariable(variable){
  let query = prop(location, 'search').substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (pair[0] === variable) {
      let value = decodeURIComponent(pair[1]);
      return value;
    }
  }
  return null;
};
export function changeUrlArg(url, arg, val){
  var pattern = arg+'=([^&]*)';
  var replaceText = arg+'='+val;
  if(!url.match(pattern)){
    return url;
  }
  return url.match(pattern) ? url.replace(eval('/('+ arg+'=)([^&]*)/gi'), replaceText) : (url.match('[\?]') ? url+'&'+replaceText : url+'?'+replaceText);
}
export function getBaseUrl(){
  const href = prop(location, 'href')
  let path = prop(location, 'pathname');
  let startPos = prop(location, 'protocol').length + 2;
  let pos = href.indexOf(path, startPos);
  let host = href.substring(0, pos);
  let baseUrl = host + '/';

  return baseUrl;
};

export function copyText(text, callback, error) {
  const area = document.createElement('textarea');
  area.value = text;
  document.body.appendChild(area);
  area.select();
  area.setSelectionRange(0, area.value.length);
  document.execCommand('copy');
  try {
    let successful = document.execCommand('copy');
    successful ? (callback && callback()): (error&&error());
  } catch (err) {
    console.error(err);
    error&&error()
    //alert('该浏览器不支持点击复制到剪贴板');

  }
  document.body.removeChild(area);
}
Date.prototype.format = function (fmt) {
  let o = {
    'M+': this.getMonth() + 1,
    'd+': this.getDate(),
    'h+': this.getHours(),
    'm+': this.getMinutes(),
    's+': this.getSeconds(),
    'q+': Math.floor((this.getMonth() + 3) / 3),
    'S' : this.getMilliseconds(),
  };
  if (/(y+)/.test(fmt)) 
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  for (let k in o)
    if (new RegExp('(' + k + ')').test(fmt)) 
      fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
  return fmt;
}

export function convertMIMETypeToFileExtension(mimeType) {
  let result = ''

  switch (mimeType) {
    case 'msword':
      result = 'doc';
      break;
    case 'vnd.openxmlformats-officedocument.wordprocessingml.document':
      result = 'docx';
      break;
    case 'vnd.ms-powerpoint':
      result = 'ppt';
      break;
    case 'vnd.openxmlformats-officedocument.presentationml.presentation':
      result = 'pptx';
      break;
    case 'vnd.ms-excel':
      result = 'xls';
      break;
    case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
      result = 'xlsx';
      break;
    case 'plain':
      result = 'txt';
      break;
    case 'gif':
      result = 'gif';
      break;
    case 'bmp':
      result = 'bmp';
      break;
    case 'jpg':
      result = 'jpg';
      break;
    case 'jpeg':
      result = 'jpeg';
      break;
    case 'png':
      result = 'png';
      break;
    case 'tiff':
      result = 'tiff';
      break;
    case 'jpx':
      result = 'jpx';
      break;
    case 'tif':
      result = 'tif';
      break;
    default:
      break;
  }

  return result
}
export function apToHex(ap){// convert opacity to hexadecimal
  let i = ap*100;
  let n = 255*i/100;
  let hexInteger = Math.round(n);
  let hex = hexInteger.toString(16);
  if (hex.length < 2) {
      hex = "0" + hex;
  }
  return hex;
}
export function colorToAARRGGBB(colorHex,ap){ // merge hex color and opacity into AARRGGBB format
  
  let apHex = apToHex(ap);
  let color = `0x${apHex}${colorHex.substr(1)}`
  return Number(color);
}
export function trimEnd(str,c) {// remove a specified trailing character or whitespace
  if (c == null || c == "") {
      let rg = /s/;
      let i = str.length;
      while (rg.test(str.charAt(--i)));
      return str.slice(0, i + 1);
  }
  else {
      let rg = new RegExp(c);
      let i = str.length;
      while (rg.test(str.charAt(--i)));
      return str.slice(0, i + 1);
  }
}
// DOMTokenList
export function getDOMTokenListValue(classList) {
  if(!classList|| classList.length===0){
    return '';
  }
  let value = !!classList.value?classList.value: '';
  if(!value){
    for (let index = 0; index < classList.length; index++) {
      const element = classList[index];
      value += element + ' ';
    }
    value = value.replace(/\s+$/g, '')
  }

  return value;
}

export function parseDateTimeString(time) {
  if(!time) {
      return null;
  }

  const reg = /^D\:(\d{4})(\d\d)(\d\d)(\d\d)(\d\d)(\d\d)(([+-]\d\d)('\d\d')?)?$/;
  const result = time.match(reg);

  if(!result) {
      return null;
  }

  const [,year,month,day,hour,minute,second,hourTimeZoneOffsetStr,minuteTimeZoneOffsetStr] = result;
  let minuteTimeZoneOffset = 0;

  if (minuteTimeZoneOffsetStr && minuteTimeZoneOffsetStr.length > 2) {
    minuteTimeZoneOffset = Number(minuteTimeZoneOffsetStr.replace(/['"]/g, ''));
    if (isNaN(minuteTimeZoneOffset)) {
      minuteTimeZoneOffset = 0;
    }
  }

  let hourTimeZoneOffset = Number(hourTimeZoneOffsetStr);

  if(isNaN(hourTimeZoneOffset)) {
      hourTimeZoneOffset = new Date().getTimezoneOffset() / -60;
  }

  let t = Date.UTC(
      Number(year),
      Number(month) - 1,
      Number(day),
      Number(hour),
      Number(minute),
      Number(second),
      0,
  );

  t + 8 * 3600 * 1000

  return new Date(t)
}

// export function debounce(fn,delay){
//   let timer = null 
//   return function() {
//       if(timer){
//           clearTimeout(timer) 
//       }
//       timer = setTimeout(fn,delay) 
//   }
// }
export function debounce(func, wait, immediate) {
  var timer;
  return function () {
      var context = this, args = arguments;
      var later = function () {
          timer = null;
          if (!immediate) {
              func.apply(context, args);
          }
      }
      var callNow = immediate && !timer;
      clearTimeout(timer);
      timer = setTimeout(later, wait);
      if (callNow) {
          func.apply(context, args);
      }
  }
}

export function getProductNameForDashboard() {
  // if (isJPDomain()) {
  //   return 'Phantom Online for JP';
  // }

  return 'Template';
}
